import React, { useState, useEffect } from 'react';
import { useOktaAuth } from '@okta/okta-react';
import { Navbar, Nav } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import '../assets/css/header.css';
import k12Logo from '../assets/images/k12_logo.png';
import Sidebar from './Sidebar';
import { SidebarMenusList } from './SidebarMenusList';
import k12LogoMobile from '../assets/images/k12-logo.svg';
import config from '../config';
import { useLinksContext } from '../context/LinksContext';
import { useOverviewContext } from '../context/OverviewContext';
import { getChatUrl, openChat } from '../utils/menuUtils';

const Header: React.FC = () => {
  const { myAccountLink, olsLink } = useLinksContext();
  const { identityId } = useOverviewContext(); 
  const [isNavOpen, setIsNavOpen] = useState(false);
  useEffect(() => {
    if (isNavOpen) {
      document.body.classList.add("nav-open"); // Add class to <body>
    } else {
      document.body.classList.remove("nav-open"); // Remove class from <body>
    }
  }, [isNavOpen]);

  const [searchValue, setSearchValue] = useState("");
  const { oktaAuth, authState } = useOktaAuth();
  const navigate = useNavigate();

  const handleChatClick = () => {
    openChat(identityId ?? undefined);
  };
  // MyAccount Header Menu
  const getAccountLink = () => {
    try {
      if (!myAccountLink) {
        console.warn("My Account link is missing.");
        return;
      }
      const cleanUrl = myAccountLink.trim().replace(/^"|"$/g, ""); 
      window.open(cleanUrl, "_blank");
    } catch (error) {
      console.error("Failed to open My Account link:", error);
    }
  };
  const getOlsLink = () => {
    try {
      if (!olsLink) {
        console.warn("OLS link is missing.");
        return;
      }
      const cleanUrl = olsLink.trim().replace(/^"|"$/g, ""); 
      window.open(cleanUrl, "_blank");
    } catch (error) {
      console.error("Failed to open OLS link:", error);
    }
  };

  const handleLogout = async () => {
    try {
      await oktaAuth.signOut({
        postLogoutRedirectUri: config.oidc.postLogoutRedirectUri, 
      });
      sessionStorage.removeItem("authToken");
    } catch (error) {
      console.error("Logout failed", error);
    }
  };
  
  return (
  <header className="sticky-top">

    <div className="container-fluid header desktop d-xl-block d-none">
      <div className="row">
        <div className='col-12 d-flex justify-content-between align-items-center gap-5 position-relative'>
          <div className="d-none" id="User_Identity_ID">{identityId}</div>

          <div className="d-flex justify-content-start align-items-center "></div>
          <div className="d-flex justify-content-end align-items-center">
              <Navbar expand="md" className="seconday-menu">
                <Navbar.Toggle aria-controls="responsive-navbar-nav" />
                <Navbar.Collapse id="responsive-navbar-nav">
                  <Nav className="ms-auto">
                    {/* <Nav.Link id="search-link" href="/search" className="nav-item">
                      Search
                    </Nav.Link> */}
                    
                    <Nav.Link id="chat-link" onClick={handleChatClick} className="nav-item">
                      Chat
                    </Nav.Link>
                    <Nav.Link id="acct" onClick={getAccountLink} className="nav-item">
                        My Account
                    </Nav.Link>
                    {authState?.isAuthenticated && (
                      <Nav.Link id="logout" onClick={handleLogout} className="nav-item">
                        Logout
                      </Nav.Link>
                    )}
                    <Nav.Link onClick={getOlsLink} className="header-btn" id="ols">
                      <button> OLS </button>
                    </Nav.Link>
                    
                  </Nav>
                </Navbar.Collapse>
              </Navbar>
          </div>

      </div>
      </div>

      {/* search-form-UI show hide*/}
      <div className="search-form show d-none">
        <div className="input-wrapper">
          <div itemType="http://schema.org/WebSite">
            <form role="search" id="searchform" className="search-form" method="get" action="#">
              <i className="fas fa-search icon" id="input-search-icon"></i>
              <input
                itemProp="query-input"
                type="search"
                id="search-field"
                value={searchValue}
                onChange={(e) => setSearchValue(e.target.value)}
                placeholder="Search site..."
                name="s"
              />
              <i className="fas fa-close close-icon"></i>
               
            </form>
          </div>
        </div>
      </div>

    </div>
    
    {/* Mobile View */}
    <div className="container-fluid header mobile-view d-xl-none">
      <div className="row">
            
              <Navbar expand="xl" className="seconday-menu">
                <div className="mobile-header">
                  <div className="header-left">
                    <a className="text-center" id="logo-div" href="/">
                      <img src={k12LogoMobile} alt="K12 Onboarding" className="img-fluid logo" />
                    </a> 
                  </div>
                  <div className="header-right">
                    {/* <Nav.Link id="search-link" href="/search" className="nav-item">&nbsp;</Nav.Link> */}
                    <Nav.Link id="chat-link" onClick={handleChatClick} className="nav-item">&nbsp;</Nav.Link>
                    <Navbar.Toggle aria-controls="responsive-navbar-nav" onClick={() => setIsNavOpen(!isNavOpen)} />
                  </div>
                </div>
                
                <Navbar.Collapse id="responsive-navbar-nav">
                  <Sidebar />
                  <Nav className="ms-auto">
                    <Nav.Link onClick={getOlsLink} className="header-btn" id="ols_mobile">
                      OLS 
                    </Nav.Link>
                    {authState?.isAuthenticated && (
                      <Nav.Link onClick={handleLogout} className="header-btn" id="logout_mobile">
                        Logout 
                      </Nav.Link>
                    )}
                  </Nav>
                </Navbar.Collapse>
              </Navbar>
          </div>

    </div>
  
  </header>

   
  );
};

export default Header;
